import React, { Component } from 'react';
import { Progress, Table } from 'reactstrap';
import { connect } from 'react-redux';
import Spinner from '@components/LoadingStyles/Spinner';
import { APP_TEXTS } from '@texts';

class CalculateNailHeader extends Component {

  render() {
    return (
      <div className="calculation">
        <section className="list-type calculation-header">
          <b>{this.props.titleText} <span className="text-uppercase">{this.props.titleContent}</span></b>
          <div className="d-flex">
            <div className="d-flex image-container">
              <img src={this.props.imageSrc || 'https://via.placeholder.com/200x60'} alt="" />
            </div>

            <Table className="w-50">
              <tbody className="tbody">
                <tr>
                  <th scope="row">Interaction</th>
                  <td>
                    <Progress
                      className="bg-white"
                      color={colorFromStatusValue(this.props.selectedItem, this.props.utilizationPercentage)}
                      value={this.props.utilizationPercentage}
                    >
                      {this.props.utilizationPercentage && this.props.utilizationPercentage.toFixed(2)}%
                    </Progress>
                  </td>
                  <td>
                    <span className={getStateIcon(this.props.selectedItem, this.props.utilizationPercentage)} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>

          {this.props.selectedItem && this.props.selectedItem.DesignMethodUsed && (
            <b>
              <span className="design-method">
                {APP_TEXTS.CALCULATE_NAIL_HEADER_DESIGN_METHOD.Content} {this.props.selectedItem.DesignMethodUsed}
              </span>
            </b>
          )}
        </section>

        <div className="calculation-errors">
          {this.props.isWaitingForErrors && <Spinner />}
          {this.props.errorMessages && this.props.errorMessages.length > 0 && (
            <ul>
              {this.props.errorMessages.map((text) => (
                <li key={text + Date.now()}>
                  <span className="icon_cancel" />
                  {text}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }

}

function getStateIcon(selItem, num, maximumValue = 100) {
  if (selItem) {
    if (Number(selItem.Status) === 2)
      return 'icon_invalid';
    else if (Number(selItem.Status) === 3)
      return 'icon_timeout';
    else {
      if (0 <= num && num <= maximumValue)
        return 'icon_check';
      else if (num > maximumValue)
        return 'icon_uncheck';
      else
        return 'icon_invalid';
    }
  }
  return 'icon_invalid';
}

function colorFromStatusValue(selItem, num, maximumValue = 100) {
  if (selItem) {
    if (selItem.Status === '2')
      return 'danger';
    else {
      if (0 <= num && num <= maximumValue)
        return 'success';
      else
        return 'danger';
    }
  }
  return "danger";
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedNailItem) {
    return {
      titleText: APP_TEXTS.CALCULATE_NAIL_HEADER_TITLE.Content,
      titleContent: data.gridSelectedNailItem.NailProduct + ' ' + data.gridSelectedNailItem.NailType,
      selectedItem: data.gridSelectedNailItem,
      imageSrc: data.nailImageSrc,
      errorMessages: data.gridSelectedNailItem.Errors,
      isWaitingForErrors: data.isWaitingForErrors,
      utilizationPercentage: data.gridSelectedNailItem.Interaction ?
        data.gridSelectedNailItem.Interaction * 100 : 0,
      appType: state.main.appType
    };
  }

  return {
    appType: state.main.appType,
    titleText: APP_TEXTS.CALCULATE_NAIL_HEADER_TITLE.Content,
  };
};

export default connect(mapState)(CalculateNailHeader); 



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateNailHeader/index.js